'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Init = void 0;
var Init = /** @class */ (function () {
    function Init() {
        this.viewTest();
    }
    Init.prototype.viewTest = function () {
        console.log('init');
    };
    return Init;
}());
exports.Init = Init;
exports.default = Init;
